import { useInitData, useUk } from '../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_40 } from '../../../../Avatar'
import Text from '../../../../Text'

import * as styles from './BotCard.module.css'

function BotCard() {
  const initData = useInitData()
  const { logo: ukLogo } = useUk()

  const logo = ukLogo?.origin

  return (
    <div className={styles.card}>
      <Avatar
        className={styles.placeholder}
        size={AVATAR_HEIGHT_40}
        src={logo}
      />
      <Text className={styles.text}>{initData.uk.name}</Text>
    </div>
  )
}

export default BotCard
